import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AfterschoolComposeComponent } from './afterschool-compose.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgModelOptionsModule } from '../../../../../../shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AfterschoolComposeService } from './afterschool-compose.service';

@NgModule({
  declarations: [AfterschoolComposeComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    NgModelOptionsModule,
    FormsModule, ReactiveFormsModule,
  ],
  providers:[AfterschoolComposeService],
  entryComponents: [AfterschoolComposeComponent],
})
export class AfterschoolComposeModule { }
